import Decimal from 'decimal.js';
import { DeliveryState, PaymentState, Workflow } from '../../../../enums/orders';
import { OrderSource, OrderType } from '../../../../interfaces/delivery-company/orders';
export const emptyOrder: OrderType = {
  id: '',
  order_id: '',
  reference_id: '',
  customer: null,
  customer_location: null,
  district: '',
  governorate: '',
  branch: null,
  driver: null,
  shelf: null,
  merchant: null,
  number_of_packages: 1,
  description: '',
  delivery_state: DeliveryState.CREATED,
  payment_state: PaymentState.UNPAID,
  tracking_hash: '',
  private_note: '',
  public_note: '',
  delivery_fee_covered_by_merchant: false,
  price: [],
  pop: [],
  delivery_fee: [],
  driver_commission: [],
  merchant_location: null,
  weight: Decimal(0),
  dimensions: [Decimal(0), Decimal(0), Decimal(0)],
  workflow: Workflow.STANDARD,
  is_critical: false,
  return_reason: "",
  is_exchange: false,
  source: OrderSource.SOURCE_MANUAL,
  packages_metadata: [],
};
